export function formatPendingSignatureDate(isoDate: string): string {
  if (!isoDate) {
    return "";
  }

  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) {
    return isoDate;
  }

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
}

export function getPendingSignatureDaysAgo(isoDate: string): number | null {
  if (!isoDate) {
    return null;
  }

  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const daysPassedInMs = Date.now() - date.getTime();
  return Math.max(0, Math.floor(daysPassedInMs / (24 * 60 * 60 * 1000)));
}
